import { ApiClientError } from '../hooks/useApiClient';

type ReauthHandler = () => void;

let reauthHandler: ReauthHandler | null = null;
let triggered = false;

export function setReauthHandler(handler: ReauthHandler): void {
  reauthHandler = handler;
}

function isAuthError(error: unknown): boolean {
  if (error instanceof ApiClientError) {
    return error.isUnauthorized;
  }

  const code = (error as { error?: string } | null)?.error;
  return code === 'login_required' || code === 'missing_refresh_token' || code === 'invalid_grant';
}

export function handleQueryError(error: unknown): void {
  if (triggered) return;
  if (!isAuthError(error)) return;

  triggered = true;
  reauthHandler?.();
}
